


//function Formulaire({children,title,handleMouse,handleMouseleave,handlekeyUpgain,onclick,count,setCount,nom,postnom,prenom,sexe,telephone,Image,setNom,setPostnom,setPrenom,setSexe,setImage,setTelephone,setNomcomplet}){
    function Formulaire({message,Iteration,my_eleve,setMy_eleve,classes,my_classe,setMy_classe,error_submission,submission,HandleSubmit,children,title,handleMouse,handleMouseleave,handlekeyUpgain,onclick,nom,postnom,prenom,sexe,date_naissance,lieu_naissance,setNom,setPostnom,setPrenom,setSexe,setDate_naissance,setLieu_naissance,setNom_complet,numero_serni,setNumero_serni,adresse,setAdresse,ideleve}){
  
    return(
       <>
       <div className="container-fluid py-5 bg-light min-vh-100">
    <div className="container">
        <div className="row g-5 justify-content-center">
            
            {/* COLONNE GAUCHE : FORMULAIRE D'INSCRIPTION */}
            <div className="col-lg-6">
                <div className="card border-0 shadow-lg rounded-4 overflow-hidden">
                    {/* Header stylisé */}
                    <div className="card-header bg-primary p-4 border-0">
                        <div className="d-flex align-items-center">
                            <div className="bg-white bg-opacity-20 p-2 rounded-3 me-3 text-white">
                                <i className="bi bi-person-plus-fill fs-3"></i>
                            </div>
                            <div>
                                <h3 className="text-white fw-bold mb-0 text-xl">{title}</h3>
                                <small className="text-white-50">Veuillez renseigner les informations de l'élève</small>
                            </div>
                        </div>
                    </div>

                    <div className="card-body p-4 p-md-5 bg-white">
                        <form className="needs-validation">
                            
                            {/* Section ID & Nom (Groupés visuellement) */}
                            <div className="row g-3 mb-4">
                                <div className="col-md-4">
                                    <label className="form-label fw-bold small text-muted">ID SYSTÈME</label>
                                    <input type="text" className="form-control form-control-lg bg-light border-0 fw-bold text-primary" value={my_eleve} readOnly />
                                </div>
                                <div className="col-md-8">
                                    <label className="form-label fw-bold small text-muted">NOM COMPLET <span className="text-danger">*</span></label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-white border-end-0 text-muted"><i className="bi bi-person"></i></span>
                                        <input type="text" className="form-control form-control-lg border-start-0 ps-0 shadow-none border-light-subtle" 
                                            placeholder="Ex: Jean Dupont" value={nom} onChange={(e)=>setNom(e.target.value.toLowerCase())} />
                                    </div>
                                </div>
                            </div>

                            {/* Section Classe & Serni */}
                            <div className="row g-3 mb-4">
                                <div className="col-md-6">
                                    <label className="form-label fw-bold small text-muted">AFFECTATION CLASSE</label>
                                    <select className="form-select form-select-lg shadow-none border-light-subtle" 
                                        onChange={(e)=>setMy_classe(e.target.value)} value={my_classe}>
                                        <option value="" disabled>Choisir la classe...</option>
                                        {classes.map((cla)=>(<option value={cla.id} key={cla.id}>{cla.nom}</option>))}
                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label fw-bold small text-muted">NUMÉRO SERNI</label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-white border-end-0 text-muted"><i className="bi bi-shield-check"></i></span>
                                        <input type="text" className="form-control form-control-lg border-start-0 ps-0 shadow-none border-light-subtle" 
                                            placeholder="N° d'identification" value={numero_serni} onChange={(e)=>setNumero_serni(e.target.value)} />
                                    </div>
                                </div>
                            </div>

                            {/* Zone dynamique (Children) */}
                            <div className="p-3 bg-light rounded-3 mb-4 border border-dashed">
                                {children}
                            </div>

                            {/* Alertes de validation */}
                            {error_submission && (
                                <div className="alert alert-danger-soft d-flex align-items-center mb-4 border-0 animate__animated animate__shakeX">
                                    <i className="bi bi-exclamation-triangle-fill me-2"></i>
                                    <span className="small fw-bold">Veuillez compléter tous les champs obligatoires</span>
                                </div>
                            )}

                            {submission && (
                                <div className="alert alert-success-soft d-flex align-items-center mb-4 border-0 animate__animated animate__fadeIn">
                                    <i className="bi bi-check-circle-fill me-2"></i>
                                    <span className="small fw-bold">{message}</span>
                                </div>
                            )}

                            {/* Bouton d'action principal */}
                            <button type="button" className="btn btn-primary btn-lg w-100 py-3 fw-bold shadow rounded-3" onClick={HandleSubmit}>
                                <i className="bi bi-save2 me-2"></i> Enregistrer l'élève
                            </button>
                        </form>
                    </div>
                </div>
            </div>

            {/* COLONNE DROITE : APERÇU / LISTE */}
            <div className="col-lg-6">
                <div className="sticky-top" style={{ top: '2rem' }}>
                    <div className="d-flex align-items-center justify-content-between mb-4">
                        <h4 className="fw-bold text-dark m-0">Aperçu Récent</h4>
                        <button className="btn btn-sm btn-outline-primary rounded-pill px-3">Voir tout</button>
                    </div>
                    {/* Le rendu de Iteration() doit être adapté pour des cartes ou une table propre */}
                    <div className="row g-3">
                        {Iteration()}
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

       </>
    )
}
export default Formulaire;